module.exports = __webpack_public_path__ + "assets/img/help_pagination01-1.1bc354c9.svg";